import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale' // Element国际化核心
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element英文包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element中文包
import elementDeLocale from 'element-ui/lib/locale/lang/de'// element德语包
import elementITLocale from 'element-ui/lib/locale/lang/it'// element意大利语包
import enLocale from './en' // 自定义英文
import zhLocale from './zh' // 自定义中文
import deLocale from './de' // 自定义德语
import itLocale from './it' // 自定义意大利语

Vue.use(VueI18n)
// 准备语言环境信息
const messages = {
    en: {
        ...enLocale,
        ...elementEnLocale
    },
    zh: {
        ...zhLocale,
        ...elementZhLocale
    },
    de: {
        ...deLocale,
        ...elementDeLocale
    },
    it: {
        ...itLocale,
        ...elementITLocale
    },
}

// 从本地存储获取语言设置，默认为英文
const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'en',
    messages,
    silentTranslationWarn: true // 关闭翻译警告
})

// 关键：将Element与Vue I18n绑定，确保Element组件跟随语言切换
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n



/*
    EN: "English",
    FR: "French",
    DE: "German",
    IT: "Italian",
    ES: "Spanish",
    PT: "Portuguese",
    NL: "Dutch",
    PL: "Polish",
    RU: "Russian",
    SV: "Swedish",
    DA: "Danish",
    NO: "Norwegian",
    FI: "Finnish",
    EL: "Greek",
    HU: "Hungarian",
    CS: "Czech",
    SK: "Slovak",
    BG: "Bulgarian",
    HR: "Croatian",
    RO: "Romanian",
    SR: "Serbian",
    SL: "Slovenian",
    ET: "Estonian",
    LV: "Latvian",
    LT: "Lithuanian",
    IS: "Icelandic",
    GA: "Irish",
    MT: "Maltese",
    CY: "Welsh",
    ZH: "Chinese",
    JA: "Japanese",
    KO: "Korean",
    AR: "Arabic",
    HI: "Hindi",
    FA: "Persian",
    UR: "Urdu",
    TR: "Turkish",
    TH: "Thai",
    VI: "Vietnamese",
    ID: "Indonesian",
    MS: "Malay",
    TL: "Tagalog",
    KM: "Khmer",
    LO: "Lao",
    MY: "Burmese",
    BN: "Bengali",
    TA: "Tamil",
    TE: "Telugu",
    SW: "Swahili",
    AF: "Afrikaans",
    AM: "Amharic",
    HA: "Hausa",
    IG: "Igbo",
    YO: "Yoruba",
    ZU: "Zulu",
    XH: "Xhosa",
    ST: "Sotho",
    HE: "Hebrew",
    UK: "Ukrainian",
    CA: "Catalan",
    EU: "Basque",
    GL: "Galician",
    LA: "Latin",
    YI: "Yiddish",
    GD: "Scottish Gaelic",
    HY: "Armenian",
    KA: "Georgian",
    MN: "Mongolian",
    NE: "Nepali",
    SI: "Sinhala",
    UZ: "Uzbek",
* */